import { Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { log } from 'utils';
import _ from 'underscore';
import { EmptyIcon } from 'assets/icon/bigicon';
import { FilterIcon } from 'assets/icon';
import ModalDelete from 'components/ModalDelete';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import ModalInformationCategoryForm from 'components/ModalInformationCategoryForm';
import {
  createInformationCategory,
  deleteInformationCategory,
  modifyInformationCategory,
  setInformationCategory,
} from 'state/actions/informationCategories';
import { deleteWebPages, fetchWebPages } from 'state/actions/webPages';
import AddWebPagesForm from './AddWebPagesForm';

const WebPagesPage = () => {
  const { siteId } = useParams();

  const {
    informationCategories,
    loading,
    userData,
    role,
    category,
    categoryLoading,
    webPagesData,
  } = useSelector(
    (state) => ({
      informationCategories: state.informationCategories.list,
      loading: state.webPages.loading,
      userData: state.auth.userData,
      role: state.auth.userData.role,
      category: state.informationCategories.category,
      categoryLoading: state.informationCategories.loading,
      webPagesData: state.webPages.list,
    }),
    shallowEqual
  );

  const [deleteModal, setDeleteModal] = useState({
    information: null,
    isOpen: false,
  });

  const dispatch = useDispatch();

  const [search, setSearch] = useState();
  const [activeCategory, setActiveCategory] = useState('all');
  const [tempSelectedCategory, setTempSelectedCategory] = useState('all');
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const [modalCategory, setModalCategory] = useState(false);
  const [dragDropElement, setDragDropElement] = useState({
    dragged: '',
    enter: '',
  });
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });

  const uid = userData.id;

  useEffect(() => {
    dispatch(fetchWebPages({ siteId }));
  }, []); // eslint-disable-line

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const dataByCategory = webPagesData.filter((information) => {
    return activeCategory !== 'all'
      ? information.categoryId === activeCategory
      : true;
  });

  const filteredData = search
    ? webPagesData.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name?.toLowerCase().includes(search.toLowerCase());
      })
    : dataByCategory;

  const getCategory = (categoryId) => {
    const findCategory = informationCategories.find(
      (cat) => cat._id === categoryId
    );
    return findCategory?.name;
  };

  const handleSetPlaylist = () => {
    setActiveCategory(tempSelectedCategory);
    setPlaylistOpen(false);
  };

  const handleEdit = (data) => {
    setSelectedPostData(data);
    setShowAddPage(true);
  };

  const onSubmitCategory = () => {
    const action = category._id
      ? modifyInformationCategory
      : createInformationCategory;

    dispatch(
      action({ uid, ...category, siteId, id: category._id }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleSetCategory = (data) => {
    dispatch(setInformationCategory(data));
  };

  const handleEditCategory = (category) => {
    dispatch(setInformationCategory(category));
    setModalCategory(true);
  };

  const handleDeleteCategory = (category) => {
    setModalDeleteCategory({
      show: true,
      category,
    });
  };

  const onDeleteCategory = () => {
    dispatch(
      deleteInformationCategory(modalDeleteCategory.category._id, () =>
        onCloseModalCategoryHandler()
      )
    );
  };

  const onCloseModalCategoryHandler = () => {
    setModalDeleteCategory({
      show: false,
      category: null,
    });
  };

  const handleNew = () => {
    dispatch(
      setInformationCategory(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalCategory(true)
      )
    );
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ information: null, id: null, isOpen: false });
  };

  const [showAddPage, setShowAddPage] = useState(false);
  const [selectedPostData, setSelectedPostData] = useState([]);

  const onRemoveButtonClickHandler = (information) => {
    setDeleteModal({
      information,
      isOpen: true,
    });
  };

  const onDeleteWebPageHandler = () => {
    dispatch(
      deleteWebPages(deleteModal.information, () => {
        onCloseModalHandler();
      })
    );
  };

  return showAddPage ? (
    <AddWebPagesForm
      predefinedData={selectedPostData}
      error={''}
      onClose={() => setShowAddPage(false)}
    />
  ) : (
    <div style={{ width: '100%', marginLeft: '16px' }}>
      <ModalDelete
        isVisible={modalDeleteCategory.show}
        onOk={onDeleteCategory}
        onCancel={onCloseModalCategoryHandler}
        title="Delete Category"
        subtitle={
          modalDeleteCategory.category ? modalDeleteCategory.category.name : ''
        }
        loading={categoryLoading}
      />

      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeleteWebPageHandler}
        onCancel={onCloseModalHandler}
        title="Delete Page"
        subtitle={deleteModal.information ? deleteModal.information.name : ''}
        loading={loading}
      />

      <ModalInformationCategoryForm
        visible={modalCategory}
        onCancel={() => {
          setModalCategory(false);
        }}
        onCreate={onSubmitCategory}
        category={category}
        setCategory={handleSetCategory}
        isEditing={!!category._id}
      />

      <div className="config-page-header">
        <div className="config-page-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                onChange={handleSearch}
              />
            </div>
          </div>
          <div
            className="playlist-wrapper"
            onClick={() => setPlaylistOpen(!playlistOpen)}
          >
            <div className="playlist-selection">
              <FilterIcon />
              <span>
                {activeCategory === 'all'
                  ? 'Show All'
                  : getCategory(activeCategory)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                playlistOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={informationCategories}
              setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
              handleEditCategory={
                role === 'superadmin' ? (cat) => handleEditCategory(cat) : null
              }
              handleDeleteCategory={
                role === 'superadmin'
                  ? (cat) => handleDeleteCategory(cat)
                  : null
              }
              modalOpen={playlistOpen}
              handleSetPlaylist={handleSetPlaylist}
              tempSelectedCategory={tempSelectedCategory}
              handleNew={role === 'superadmin' ? handleNew : null}
              filter
            />
          </div>
        </div>
        <div className="actions__wrapper">
          <div
            onClick={() => {
              setShowAddPage(true);
              setSelectedPostData([]);
            }}
            className="btn-primary"
          >
            <i className="feather-plus mr-2" />
            Add Page
          </div>
        </div>
      </div>

      <div className="config-page-content-wrapper">
        <div className="config-page-content">
          <div className="config-page-list-content">
            {webPagesData.length > 0 && filteredData.length > 0 ? (
              _.chunk(filteredData, 3).map((chunk, index) => {
                return (
                  <div className="config-page-list-chunk" key={index}>
                    {chunk.map((data) => {
                      return (
                        <div
                          key={data._id}
                          data-id={data._id}
                          className={`config-page-list ${
                            dragDropElement.dragged === data._id
                              ? 'dragged'
                              : ''
                          } ${
                            dragDropElement.enter === data._id ? 'entered' : ''
                          }`}
                          draggable
                          onDragStart={() =>
                            setDragDropElement({
                              ...dragDropElement,
                              dragged: data._id,
                            })
                          }
                          onDragEnd={() =>
                            setDragDropElement({
                              ...dragDropElement,
                              dragged: '',
                            })
                          }
                          onDragEnter={() => {
                            setDragDropElement({
                              ...dragDropElement,
                              enter: data._id,
                            });
                          }}
                          onDragOver={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onDrop={() => {}}
                        >
                          <Cards
                            data={data}
                            type="web-pages"
                            isDelete={true}
                            editAction={() => handleEdit(data)}
                            deleteAction={() =>
                              onRemoveButtonClickHandler(data._id)
                            }
                          />
                        </div>
                      );
                    })}
                    {chunk.length < 2 && (
                      <div className="config-page-list-empty" />
                    )}
                    {chunk.length < 3 && (
                      <div className="config-page-list-empty" />
                    )}
                  </div>
                );
              })
            ) : (
              <div className="config-page-empty">
                <Empty image={<img src={EmptyIcon} alt="empty" />} description="No Page" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebPagesPage;
